import React from 'react';

// eslint-disable-next-line import/no-anonymous-default-export
export default (props) => {
  const title = props.title || props.children || 'Loading...3...2...1...';
  return (<div style={{textAlign: 'center'}}>{title}</div>)
}
